import { AppBar, IconButton, Toolbar } from "@mui/material";
import React, { useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import { useContentSetting } from "../../Hooks/ContentSetting";
import ThemeToggle from "../../components/GeneralComponents/ThemeToggle";
import ShellAccountActions from "../../components/Header/ShellAccountActions";

export default function AppHeader({
  drawerWidth,
  handleDrawerToggle,
  handlePermanentDrawer,
  hideNavigation = false,
}) {
  const { socket } = useContentSetting();
  const { enqueueSnackbar } = useSnackbar();
  const { pathname } = useLocation();

  const handle_show_report_notification = (data) => {
    enqueueSnackbar(data.message, { variant: "info", autoHideDuration: 25000 });
  };

  useEffect(() => {
    socket.on("added_report_by_student", (data) => {
      handle_show_report_notification(data);
    });

    return () => {
      socket.off("added_report_by_student");
    };
  }, [socket]);

  useEffect(() => {
    setTimeout(() => {
      const includes_path = (path) => {
        return pathname.toString().includes(path);
      };
      if (!includes_path("/students")) {
        localStorage.removeItem("students_filter");
      }
    }, 1000);
  }, [pathname]);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
        className="app-header"
      >
        <Toolbar>
          {!hideNavigation ? (
            <>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { xs: "block", sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handlePermanentDrawer}
                sx={{ mr: 2, display: { xs: "none", sm: "block" } }}
              >
                <MenuIcon />
              </IconButton>
            </>
          ) : null}
        </Toolbar>
        <div className="d-flex gap-3 pe-3 align-items-center">
          <ThemeToggle variant="header" />
          <ShellAccountActions />
        </div>
      </AppBar>
    </>
  );
}
